import { TwinDictionary } from '../../../../../../utils/globals/dictionary';
import { RowData } from '../../../../types';

export const blockedItemsFncITSpecificPriceRule = (items: TwinDictionary, CurrencyId: string) => {
    for (const key in items) {
        const item = items[key]
        items[key] = { ...item, is_blocked: item.CurrencyId !== CurrencyId }
    }
    return items
}

export const sortITSpecificPriceRule = (items: TwinDictionary) => {
    const result: any[] = []
    const itemsBlocked: any[] = []
    for (const key in items) {
        const item = items[key]
        const myItem = { ...item, value: key, text: items[key]?.fullname }
        if(item.is_blocked){
            itemsBlocked.push(myItem)
        }else{
            result.push(myItem)
        }
    }
    result.sort((a, b) => {
        return a?.order > b?.order ? 1 : -1
    })
    itemsBlocked.sort((a, b) => {
        return a?.order > b?.order ? 1 : -1
    })

    return [...result, ...itemsBlocked]
}

export const checkIfScaleProduct = (allRowData: RowData) => {
    if ((allRowData.ScaleOrderProductId || allRowData.ScaleVariableId) && allRowData.scaleQuantity) {
        return true
    }
    return false
}

export const checkIfScaleProductWithoutVariables = (allRowData: RowData) => {
    if (allRowData.ScaleOrderProductId && allRowData.scaleQuantity) {
        return true
    }
    return false
}